<template>
  <div v-if="locations.length > 1">
    <div class="input__label">
      <div class="leading-relaxed text-xs lg:text-sm uppercase font-700">{{ $t(fieldLabel) }}:</div>
    </div>


    <div class="input__field ">
          <label class="label mb-2" v-for="(location, index) of locations" :key="index" >
            <input type="radio" v-model="selectedLocation" :id="CreatePropertyId(fieldLabel, index)" :name="fieldLabel" :value="location" />
            <span>{{ $t("locations."+location.name) }}</span>
          </label>
    </div>
  </div>
</template>

<script>
    import HtmlPropertyHelper from '@/mixins/HtmlPropertyHelper';
    import CaagApi from '@/mixins/CaagApi';

    export default {
        name: 'Locations',
        mixins: [HtmlPropertyHelper, CaagApi],
        props: {
            fieldLabel: String,
            currentLocationId: Number
        },
        computed: {
            selectedLocationId: function() {
                if ( this.selectedLocation ) {
                    return this.selectedLocation.id;
                }
                else {
                    return null;
                }
            }
        },
        mounted() {
            var obj = this
            this.getLocations(this.currentLocationId).then(function(){
                if(obj.locations.length == 1){
                    obj.$emit('changeLocation', {
                        pickupLocation: obj.locations[0],
                        returnLocation: obj.locations[0]
                    })
                }
            })
          
        },
        watch: {
            selectedLocation: function(val) {               
                let returnLocation = this.getReturnLocation()
                if ( !returnLocation ) {
                    returnLocation = val
                }

                this.$emit('changeLocation', {
                    pickupLocation: val,
                    returnLocation: returnLocation
                });
            }
        },
        methods: {
            getFieldId: function(index) {
                return this.fieldLabel.replace(' ', '_') +'_'+ index;
            }
        }
    }
</script>
